<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <form id="timePolicyForm">
        <div class="h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.Strategy.name')}}</div>
              <input
                id="policyName"
                class="e-input e-input-group"
                name="PolicyName"
                v-model="policyName"
                :placeholder="$t('Security.placeholder.strategyName')"
                :disabled="nameRead"
                @change="setChildProps"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox">
        <ejs-checkbox :label="$t('Security.Strategy.date')" ref="dateCheck" :checked="true" :change="setDateState"></ejs-checkbox>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox h-security-leftInput">
        <ejs-datepicker
          ref="startDate"
          class="e-input e-disabled e-input-group"
          :format="dateFormat"
          v-model="startDate"
          @change="setChildProps"
          :enabled="dateRead"
          :locale="locale"
        ></ejs-datepicker>
      </div>
      <div class="h-security-middleText">{{$t('Security.Strategy.to')}}</div>
      <div class="h-col-inputBox h-security-rightInput">
        <ejs-datepicker
          ref="endDate"
          class="e-input e-disabled e-input-group"
          :format="dateFormat"
          v-model="endDate"
          @change="setChildProps"
          :enabled="dateRead"
          :locale="locale"
        ></ejs-datepicker>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox">
        <ejs-checkbox :label="$t('Security.Strategy.time')" ref="timeCheck" :checked="true" :change="setTimeState"></ejs-checkbox>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox h-security-leftInput">
        <ejs-timepicker
          class="e-input e-disabled e-input-group"
          v-model="startTime"
          :enabled="timeRead"
          :format="customFormat"
          @change="setChildProps"
        ></ejs-timepicker>
      </div>
      <div class="h-security-middleText">{{$t('Security.Strategy.to')}}</div>
      <div class="h-col-inputBox h-security-rightInput">
        <ejs-timepicker
          class="e-input e-disabled e-input-group"
          v-model="endTime"
          :enabled="timeRead"
          :format="customFormat"
          @change="setChildProps"
        ></ejs-timepicker>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox">
        <ejs-checkbox :label="$t('Security.Strategy.weekday')" ref="weekCheck" :checked="true" :change="setWeekState"></ejs-checkbox>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-borderBox h-blueBg">
          <div class="row h-row-insertBox">
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week7'
                :label="$t('Security.Strategy.sunday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="7"
              ></ejs-checkbox>
            </div>
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week1'
                :label="$t('Security.Strategy.monday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="1"
              ></ejs-checkbox>
            </div>
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week2'
                :label="$t('Security.Strategy.tuesday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="2"
              ></ejs-checkbox>
            </div>
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week3'
                :label="$t('Security.Strategy.wednesday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="3"
              ></ejs-checkbox>
            </div>
          </div>
          <div class="row h-row-insertBox">
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week4'
                :label="$t('Security.Strategy.thursday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="4"
              ></ejs-checkbox>
            </div>
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week5'
                :label="$t('Security.Strategy.friday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="5"
              ></ejs-checkbox>
            </div>
            <div class="col-sm-3 h-col-insertBox">
              <ejs-checkbox
                ref='week6'
                :label="$t('Security.Strategy.saturday')"
                name="week"
                :checked="false"
                :change="setChildProps"
                :disabled="weekRead"
                value="6"
              ></ejs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.User.desc')}}</div>
            <ejs-textbox
              id="description"
              name="Description"
              v-model="description"
              :multiline="true"
              @blur="setChildProps"
              maxLength='40'
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../mixin/mixin';


export default {
  name: "TimePolicyCom",
  mixins:[mixin],
  data() {
    return {
      policyName: "",
      nameRead: false,
      startDate: "",
      dateFormat: "yyyy-MM-dd",
      dateRead: true,
      endDate: "",
      startTime: "00:00",
      timeRead: true,
      customFormat: "HH:mm",
      endTime: "23:59",
      description: "",
      weekRead: false,
      inputNames: ['PolicyName'],
      rules: { PolicyName: { required: true, maxLength: 20 }},
      formObj: "",
      locale: localStorage.getItem('locale')
    };
  },
  methods: {
    setChildProps() {
      let dateReadCh = 0;
      let timeReadCh = 0;
      let weekReadCh = 0;
      if (this.dateRead) {
        dateReadCh = 0;
      } else {
        dateReadCh = 1;
      }
      if (this.timeRead) {
        timeReadCh = 0;
      } else {
        timeReadCh = 1;
      }
      if (this.weekRead) {
        weekReadCh = 1;
      } else {
        weekReadCh = 0;
      }
      let weekArray = document.getElementsByName("week");
      let weekStr = [];
      weekArray.forEach(item => {
        if (item.checked) {
          weekStr.push(item.value);
        }
      });
      let trStime = this.startTime;
      if (trStime instanceof Date) {
        trStime = this.trTime(this.startTime.getHours()) + ':' + this.trTime(this.startTime.getMinutes());
      }
      let trEtime = this.endTime;
      if (trEtime instanceof Date) {
        trEtime = this.trTime(this.endTime.getHours()) + ':' + this.trTime(this.endTime.getMinutes());
      }
      this.$emit("childProps", {
        policyName: this.policyName,
        dateRead: dateReadCh,
        startDate: this.startDate,
        endDate: this.endDate,
        timeRead: timeReadCh,
        startTime: trStime,
        endTime: trEtime,
        description: this.description,
        weekRead: weekReadCh,
        week: weekStr.join(",")
      });
    },
    // 补全小时和分钟字符
    trTime(hour){
      return hour < 10 ? '0' + hour: hour;
    },
    setDateState() {
      const checked = this.$refs.dateCheck.ej2Instances.checked;
      this.dateRead = checked;
      this.setChildProps();
    },
    setTimeState() {
      const checked = this.$refs.timeCheck.ej2Instances.checked;
      this.timeRead = checked;
      this.setChildProps();
    },
    setWeekState() {
      const checked = this.$refs.weekCheck.ej2Instances.checked;
      this.weekRead = !checked;
      this.setChildProps();
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    bindValidate() {
      this.formObj = this.validateForm('timePolicyForm', this.inputNames, this.rules);
      let start_t = new Date();
      start_t.setHours(0);
      start_t.setMinutes(0);
      start_t.setSeconds(0);
      let end_t = new Date();
      end_t.setHours(23);
      end_t.setMinutes(59);
      end_t.setSeconds(59);
      this.startTime = start_t;
      this.endTime = end_t;
    },
    edit(editParams){
      this.nameRead = true;
      this.policyName = editParams.name;
      this.startDate = editParams.startDate;
      this.endDate = editParams.endDate;
      if (this.startDate == '' && this.endDate == '') {
        this.$refs.dateCheck.ej2Instances.checked = false;
        this.dateRead = false;
      }
      const time = editParams.time.split("~");
      if (time[0] == '' && time[1] == '') {
        this.$refs.timeCheck.ej2Instances.checked = false;
        this.timeRead = false;
      }
      this.startTime = time[0];
      this.endTime = time[1];
      this.description = editParams.des;
      const week = editParams.week.split(",");
      if (week[0] == '') {
        this.$refs.weekCheck.ej2Instances.checked = false;
        this.setWeekState();
      } else {
        const weekArray = document.getElementsByName("week");
        weekArray.forEach(item => {
          if (week.indexOf(item.value) != -1) {
            this.$refs['week' + item.value].ej2Instances.checked = true;
          }
        });
      }
    }
  }
};
</script>
